import api from './base'

export default {
  getAll ({ businessUnitId }) {
    return api().get(`company/business_units/${businessUnitId}/electronic_devices`)
  },
  getById ({ businessUnitId, id }) {
    return api().get(`company/business_units/${businessUnitId}/electronic_devices/${id}`)
  },
  getHeader ({ electronicDeviceId, headers }) {
    if (headers) {
      return api().get(`company/electronic_devices/${electronicDeviceId}/invoice_header`, { headers: headers })
    } else {
      return api().get(`company/electronic_devices/${electronicDeviceId}/invoice_header`)
    }
  },
  getFooter ({ electronicDeviceId, headers }) {
    if (headers) {
      return api().get(`company/electronic_devices/${electronicDeviceId}/invoice_footer`, { headers: headers })
    } else {
      return api().get(`company/electronic_devices/${electronicDeviceId}/invoice_footer`)
    }
  },
  sourceFile ({ deviceId, childCompanyId, businessUnitId, dateFrom, dateTo }) {
    return api().get(`company/child_companies/${childCompanyId}/business_units/${businessUnitId}/electronic_devices/${deviceId}/source_file?dateFrom=${dateFrom}&dateTo=${dateTo}`)
  },
  currentState ({ electronicDeviceId }) {
    return api().get(`company/electronic_devices/${electronicDeviceId}/current_state`)
  }
}
